export const Shadows = {
  DialogDarkMode: '6px 6px 20px rgba(26, 14, 62, 0.1)',
  DialogLightMode: '6px 6px 20px rgba(26, 14, 62, 0.1)',

  SnackbarDarkMode: '-12px 14px 34px 0px rgba(84, 77, 104, 0.15)',
  SnackbarLightMode: '-12px 14px 34px 0px rgba(84, 77, 104, 0.15)',

  DrawerDarkMode: `-30px 15px 70px 0px rgba(0, 0, 0, 0.3)`,
  DrawerLightMode: '-30px 15px 50px 0px rgba(61, 57, 74, 0.05)',

  HeaderLightMode: '0px 4px 4px 0px rgba(14, 20, 72, 0.02)',
  HeaderDarkMode: '0px 4px 4px 0px rgba(14, 20, 72, 0.02)',

  LegendLightMode: '8px 7px 20px 0px rgba(92, 83, 120, 0.08)',
  LegendDarkMode: '8px 7px 20px 0px rgba(92, 83, 120, 0.08)',

  BlocksLightMode: '4px 6px 25px 0px rgba(47, 46, 70, 0.04)',
  BlocksDarkMode: '4px 6px 25px 0px rgba(47, 46, 70, 0.04)',

  PopoverLightMode: '18px -24px 44px rgba(57, 65, 74, 0.05)',
  PopoverDarkMode: '18px -24px 44px rgba(57, 65, 74, 0.05)',
} as const;
